import React, {createContext} from 'react';
import {Row, Col, Button, Modal, Icon, Tooltip, Spin} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import {message} from "../../../../utils/message";
import ActivitiModal from "../../../../view/activiti/ActivityModal";
import SyncModal from "../../../../view/components/syncModal/syncModal";
import {Scrollbars} from "react-custom-scrollbars";
import {fixedFieldConfig} from "./fixedFieldsConfig";
import FormItem from "./formItemTemplate/formItem";
import {regulation} from "./extendFieldsConfig";
import {getActHistory, getActivityTypeData} from "../../../newMediaMatrix/actions/actions";
import AuditRecord from "../AuditRecord";
import AuditRemarks from "./auditRemarks/AuditRemarks";
import {uuid} from "../../../../utils";
import {showOrHide} from "./utils/utils";
import SendRemind from "../sendRemind/sendRemind";
import { CUSTOM_CONFIG } from '../../../../config/customConfig';
import eventProxy from '../../../../utils/eventProxy';

export const PositionTypeContext = createContext();

export default class PositionAdd extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    static footerStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
    };

    constructor(props) {
        super(props);
        this.state = {
            showNewAdd: true, //加载流程配置
            isRepeatClick: true, //设置开关来控制重复点击
            formData: {
                ext: {}, //动态字段
                activityExt: {},  //审核备注数据
            }, //表单数据
            variableFieldsSetting: [],  //维护字段数据
            activityOption: {}, //流程配置参数
            id: "",
            onlyEdit: false,  //是否只保存
            activityTypeData: [], //流程类型数据
            isUpdateInfo: false, //是否可编辑
            openStatus: false,//按钮展开状态
            bottomBtnLoading: true, //底部按钮loading
            loadAuditRemarks: uuid(), //加载审核备注
            cancelRecord: false, //是否直接注销未备案
            positionRecordOnlineOpen: false, //是否可下载备案表
            updateContentStatus: false, //是否可修改内容
            activitiKey: uuid(),
        }
    }

    componentDidMount() {
    }

    initData(data) {
        this.getActivityType().then((activityTypeData) => {
            this.setState({activityTypeData});
            // 加载流程
            if (this.getCommonCondition(data) ||
                (data.cancelRecord && data.statusName !== this.signOutName) //特殊的：注销未备案操作 已注销后不需要加载流程
            ) {
                return this.initActivityConfig(data); // 流程配置
            }
        }); //流程类型数据
    }

    // 公共条件
    getCommonCondition = (data = {}) => {
        let condition1 = this.isAuditInProgress(); // 审核中状态
        let condition2 = !data.id; //新增
        let condition3 = !data.statusName; //新增
        let condition4 = data.statusName === "草稿"; //草稿状态
        let condition5 = this.reloadLingQuActivity.indexOf(data.statusName) > -1; //待领取状态
        let condition6 = (data.processType === 0 && data.statusName && data.statusName.indexOf("审核不通过") > -1); //新增流程 && 审核不通过
        return (condition1 || condition2 || condition3 || condition4 || condition5 || condition6);
    }

    sysConfigStatus = this.sysConfigGetValueByKey("positionManage.activiti.config.status", "退回修改,草稿");

    beforeUpdateStatusFunction = [];

    reloadLingQuActivity = this.sysConfigGetValueByKey("positionManage.activiti.loadLingQuChart.status", "待领取");

    grades = this.sysConfigGetValueByKey("positionManage.showBtn.grade.value", "");

    platformDivide = this.sysConfigGetValueByKey("position.platform.divide.screen", "no");

    /**设置流程配置*/
    initActivityConfig(data) {
        let id = (this.state.id && this.state.id.length > 1 && this.state.id != 'null' && this.state.id != 'undefined') ? this.state.id : '';
        let that = this;
        let {activityTypeData = []} = this.state;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        let userId = (window.currentUser && window.currentUser.id) ? window.currentUser.id : "";
        let deptId = window.currentUser?.defaultInfo?.dept?.id || "";

        //获取系统设置流程
        let activitiConfName = "activitiTreeRoot-position_record_audit";
        if (!activityTypeData.find((item) => item.type === data.processType)) {
            message.info("流程类型配置错误");
            return;
        }
        activitiConfName = activityTypeData.filter((item) => item.type === data.processType)?.[0].code;

        // 待领取流程（特殊）
        if (data.statusName && this.reloadLingQuActivity.indexOf(data.statusName) > -1) {
            activitiConfName = "activitiTreeRoot-position_lingQu_audit";
        }

        // 流程结束 || 草稿  =>>>  流程重启
        let againFlag = false;
        if ((!this.isAuditInProgress() || data.statusName === "草稿") && this.reloadLingQuActivity.indexOf(data.statusName) === -1) {
            againFlag = true;
        }
        // 待领取状态下 并且 界面所选所属部门===当前用户所属部门 可以领取阵地
        if (data.statusName && this.reloadLingQuActivity.indexOf(data.statusName) > -1 && window?.currentUser?.defaultInfo?.dept?.id === data.belongDeptId) {
            againFlag = true;
        }

        // 所属人是当前用户  ||  新增  ||  分派  ||  领取  -------> 加载activityConf
        let isHaveAssignAuth = (!data.statusName || data.belongUserAccount === userId || data.createById === userId) && this.permissionCheck("pms:positionManage:assignPosition");
        let activitiConf = activitiConfName && (data.belongDeptId===deptId || !data.statusName || isHaveAssignAuth || this.reloadLingQuActivity.indexOf(data.statusName) > -1) ? {type: activitiConfName} : null;
        if(!activitiConf && againFlag) {
            this.setState({
                bottomBtnLoading: false,
            })
        }
        this.state.activityOption = {
            id: id,//流程id
            editor:that,
            activitiConf,//流程conf
            pojoName: 'positionAudit',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag: true,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {
                callBackBtnShow: (item, call) => {
                    call({code: 0, log: "不显示撤回按钮！"});
                },
                showSubmitBtnByGrade: (item, call) => {
                    if (that.grades.indexOf(data?.ext?.grade||data.grade) > -1) {
                        call({code: 0, log: "不显示提交流程按钮！"});
                    } else {
                        call({code: 1, log: "显示提交流程按钮！"});
                    }
                },
                showPassBtnByGrade: (item, call) => {
                    if (that.grades.indexOf(data?.ext?.grade||data.grade) > -1) {
                        call({code: 1, log: "显示通过流程按钮！"});
                    } else {
                        call({code: 0, log: "不显示通过流程按钮！"});
                    }
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                /**
                 * 校验是否存在流程候选人
                 * 当推进流程时，不存在保存按钮时，需要借用此js组织保存接口的调用
                 * */
                checkUser: function (activiti, buttonConf, call) {
                    let lineJavaScript = buttonConf.document.lineJavaScript;
                    let temp = {};
                    if (lineJavaScript.auditorMap.FORM_SERVICE_SAME_GROUP && lineJavaScript.auditorMap.FORM_SERVICE_SAME_GROUP === "true") {
                        if (window?.currentUser?.defaultInfo?.dept?.id) {
                            lineJavaScript.auditorMap.FORM_SERVICE_GROUP = [window?.currentUser?.defaultInfo?.dept?.id]
                        }
                    }
                    if (lineJavaScript.auditorMap.FORM_SERVICE_GROUP) {
                        temp.group = lineJavaScript.auditorMap.FORM_SERVICE_GROUP
                    }
                    if (lineJavaScript.auditorMap.FORM_SERVICE_ROLE) {
                        temp.role = lineJavaScript.auditorMap.FORM_SERVICE_ROLE;
                    }
                    if (lineJavaScript.auditorMap.RECURSION_LOOKUP_GROUP_CANDIDATE === "true") {
                        temp.recursionDept = "true";
                    }
                    activiti.getUser(temp, activiti, function (users) {
                        if (users?.length) {
                            call({code: 1, log: "存在流程候选人，继续推进流程"});
                        } else {
                            activiti.load.end();
                            call({code: -1, log: "流程候选人为空，不能进行推进！"});
                        }
                    })
                },
                /**
                 * 修改完成后直接提交给返回的人 不经过中间审核
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callAgent: function (activiti, buttonConf, call) {
                    let uuid = activiti.options.uuid;
                    getActHistory({bizKey: uuid}, (data) => {
                        let historyList = data;
                        let nextProcessInfos = [];
                        let nextProcessNames = [];
                        /**
                         * 查找上一步流程操作人：
                         * 如果[0]是撤回流程，则[1]是被撤回的流程，此时应该找第[2]条记录，如果[2]条记录依然是撤回，则继续往上找
                         * */
                        let getAgent = (list = [], index = 0) => {
                            let item = list?.[index];
                            if (!item) {
                                return
                            }
                            if (item?.taskName === '撤回') {
                                getAgent(list, index + 2)
                            } else {
                                nextProcessNames = [item.operatorName];
                                nextProcessInfos = [
                                    {
                                        id: item.operatorUserInfo.userId,
                                        name: item.operatorName,
                                        deptId: item.operatorUserInfo.deptId
                                    }
                                ];
                            }
                        }
                        getAgent(historyList)
                        if (nextProcessInfos?.length) {
                            activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = nextProcessInfos;
                            call({code: 1, log: "查询到返回者为：" + nextProcessNames.join(',')});
                        } else {
                            call({code: -1, msg: "未查询到返回者！"})
                        }
                    })
                },
                confirmOperate: function (activiti, buttonConf, call) {
                    let signOutText = that.sysConfigGetValueByKey("position.manage.signOut.title", "注销后无法恢复，请问是否注销？");
                    let deleteText = that.sysConfigGetValueByKey("position.manage.delete.title", "账号删除之后所有数据都会删除，请问还要继续吗？");
                    let linQuText = that.sysConfigGetValueByKey("position.manage.get.title", "领取操作不可撤回，可对账号进行编辑或提交审核等操作，请问是否领取？");
                    const activityTypeName = (activityTypeData && activityTypeData.filter(item => item.type !== 0).find(item => item.type === data.processType)?.name) || '';
                    if (!activityTypeName) {
                        call({code: 1, log: "confirmOperate"});
                        return;
                    }
                    that.checkForm(activiti, () => {
                        activiti.load.end();
                        let msgContent = '申请' + activityTypeName + '信息后需重新审核，\n' +
                            '\n' +
                            '请问还要继续吗？';
                        if (data.processType === 2) {  //注销
                            msgContent = signOutText;
                        }
                        if (data.processType === 3) {  //删除
                            msgContent = deleteText;
                        }
                        if (buttonConf.btnName.indexOf("领取") > -1) {
                            msgContent = linQuText;
                        }
                        Modal.confirm({
                            title: msgContent,
                            okText: '确定',
                            cancelText: '取消',
                            onOk() {
                                call({code: 1, log: "confirmOperate"});
                            },
                            onCancel() {
                            },
                        })
                    });
                },
                /**
                 * 撤稿前置js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callActRevert: function (activiti, buttonConf, call) {
                    activiti.terminate.call(activiti, function (res, statusNameTemp) {
                        if (res) {
                            activiti.options.statusNameTemp = statusNameTemp || "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if (res) {
                                    if (res.status) {
                                        activiti.successMsg("流程已撤回", function () {
                                            activiti.submitOK.call(activiti);
                                        });
                                    } else {
                                        window.loading.hide();
                                    }
                                } else {
                                    window.loading.hide();
                                }
                            })
                        }
                    });
                },
                /**
                 * 确认分派js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                confirmAssignment: function (activiti, buttonConf, call) {
                    that.checkForm(activiti, () => {
                        that.state.formData["processType"] = 5;
                        that.beforeUpdateStatusFunction.push(that.confirmAssignment.bind(that));
                        call({code: 1, log: "confirmAssignment"});
                    })
                },
                /**
                 * 领取js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                receive: function (activiti, buttonConf, call) {
                    that.state.formData["belongUserAccount"] = window.top.currentUser.id;
                    that.beforeUpdateStatusFunction.push(that.receive.bind(that));
                    call({code: 1, log: "receive"});
                },
            },//流程按钮点击事件前置js
            saveFunction: that.onOk,//稿件保存方法
            closeServiceTemp: [
                function clearAfterEndFunction(activiti, param, call) {
                    that.beforeUpdateStatusFunction = [];
                    call({code: 1})
                },
            ],
            saveStatusNameFunction: (statusName, activiti, call) => {
                activiti.util.executeFunctionChain(that.beforeUpdateStatusFunction, activiti, {}, function () {
                    return call && call({status: true, msg: "流程推进后状态修改成功。"});
                    that.updateStatusName(statusName, activiti, call);
                })
            },//改流程状态方法
            onSubmitOK: function (activiti) {
                that.onOkCall();
                if (typeof CUSTOM_CONFIG?.POSITIONADD?.ANNUALAUDIT == "function") {
                    CUSTOM_CONFIG.POSITIONADD.ANNUALAUDIT(that)
                }

            },//流程事件运行完毕的回调
            successCall: () => {
                if (typeof CUSTOM_CONFIG?.EDITOR?.CUSTOM_SUCCESS_CALL === 'function') {
                    CUSTOM_CONFIG.EDITOR.CUSTOM_SUCCESS_CALL(data);
                }
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver: (buttons, call, activiti) => {
                // 拿到这三个参数，重新渲染流程按钮
                this.activitiBtns = buttons;
                this.call = call;
                this.activiti = activiti;
                this.state.bottomBtnLoading = false;
                this.setState({});
            },
            showBtnIcon: false,
            btnType: "primary",
            getTextTitle: "审核意见",
            checkForm: that.checkForm,
            showRemarks: (remarks) => {
                if (remarks && remarks.length) {
                    this.setState({showRemarks: true, remarks})
                }
            },//备注回显
        };
        // 审核中 || 新增 || 草稿  显示附加信息
        if (this.getCommonCondition(data) || this.state.openStatus) {
            this.auditRemarks.setFormData(data.processType, data.activityExt, activityTypeData);
        }
        this.setState({showNewAdd: false,activitiKey:uuid()})
    }

    confirmAssignment = (activiti, param, call) => {
        activiti.successMsg("确认分派成功", function () {
            activiti.submitOK.call(activiti);
        })
    }

    receive = (activiti, param, call) => {
        activiti.successMsg("领取成功", function () {
            activiti.submitOK.call(activiti);
        })
    }

    getActivityType() {
        return new Promise((resolve, reject) => {
            let params = {
                pageNum: 1,
                pageSize: 10
            };
            getActivityTypeData(params, (res) => {
                let activityTypeData = [];
                if (res && res.data && res.data.length) {
                    activityTypeData = res.data;
                }
                resolve(activityTypeData)
            })
        })
    }

    getValue = (dbFieldName) => {
        if (typeof parseInt(dbFieldName) === "number") {
            return "this.state.formData.ext['" + dbFieldName + "']";
        } else {
            return "this.state.formData.ext." + dbFieldName;
        }
    }

    getValueByKey = (dbFieldName) => {
        return this.state.formData.ext[dbFieldName];
    }

    // 获取表单配置项
    getExtendsField = (typeId) => {
        let url = "/cm-sites-media-consumer/system/positionField/getByPositionTypeId";
        let body = {typeId};
        // 解决流程中添加字段流程卡死问题  （审核中状态 || 待领取）
        if (this.isAuditInProgress() || this.reloadLingQuActivity.indexOf(this.state.formData.statusName) > -1) {
            url = "/cm-sites-media-consumer/system/positionField/getByPositionId";
            body = {id: this.state.formData.id}
        }
        this.request({
            url: url,
            body: body,
            callBack: (res) => {
                let variableFieldsSetting = [];
                if (res && res.length && (res.filter(item => item.status).length)) {
                    variableFieldsSetting = res.filter(item => item.status).map(item => ({
                        col: item.col,
                        componentType: regulation[item.fieldType],
                        value: this.getValue(item.dbFieldName),
                        labelName: item.fieldName,
                        labelCode: item.dbFieldName,
                        fieldProps: {
                            placeholder: this.getPlaceHolderText(item, item.fieldName),
                            message: this.getPlaceHolderText(item, item.fieldName),
                            size: "default", // 标签大小
                            options: item.fieldFillRules?.[0]?.keyValueMaps && Object.keys(item.fieldFillRules[0].keyValueMaps).length && Object.keys(item.fieldFillRules[0].keyValueMaps).map(i => ({
                                key: i,
                                label: item.fieldFillRules[0].keyValueMaps[i]
                            })),
                            fieldFillRules: item.fieldFillRules,
                            display: item.status ? "block" : "none",
                            disabled: false,
                            fieldType: item.fieldType,
                            fieldTip: item.fieldTip,
                            uploadCount: item.fieldFillRules && item.fieldFillRules?.[0]?.uploadCount,
                            show: item.show,
                            canEdit: item.canEdit,
                            confirmContent: item.fieldFillRules && item.fieldFillRules?.[0]?.confirmContent,
                        },
                        options: {
                            rules: this.setRules(item.fieldFillRules)
                        },
                        maxLength: 999,
                        required: item.required === -1 ? false : !!item.required,
                        id: "position_" + item.dbFieldName,
                    }));
                }
                this.setState({
                    variableFieldsSetting
                });
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };

    getPlaceHolderText(item, fieldName) {
        let requiredTip = item?.requiredTip;
        if ((typeof requiredTip === "number" && (requiredTip || requiredTip === 0)) ||
            (requiredTip && typeof requiredTip === "string" && requiredTip?.trim()?.length) ||
            (requiredTip && Array.isArray(requiredTip) && requiredTip?.length) ||
            (requiredTip && typeof requiredTip === 'object' && !Array.isArray(requiredTip) && Object.keys(requiredTip).length)
        ) {
            return requiredTip;
        } else {
            if (item.fieldType === 9) {
                return "请上传" + fieldName;
            } else if (item.fieldType === 1 || item.fieldType === 2 || item.fieldType === 7) {
                return "请输入" + fieldName;
            } else {
                return "请选择" + fieldName;
            }
        }
    }

    setRules(fieldFillRules) {
        let ruleArr = [];
        fieldFillRules && fieldFillRules.map(rule => {
            if (rule.ruleType === 0 && rule.length > 0) {
                ruleArr.push({
                    message: `内容不能超过${rule.length}个字`,
                    max: rule.length,
                    ruleType: rule.ruleType
                })
            }
            if (rule.ruleType === 1 && rule?.fieldRegularExpression) {
                ruleArr.push({
                    pattern: rule?.fieldRegularExpression?.regularDetails,
                    message: rule?.fieldRegularExpression?.regularTips,
                    ruleType: rule.ruleType
                })
            }
        })
        return ruleArr;
    }

    render() {
        return (
            <>
                {this.renderAddModal()}
            </>
        )
    }

    // 组图弹窗
    renderAddModal = () => {
        return (
            <Modal
                centered={true}
                title={this.state.title}
                visible={this.state.addVisible}
                maskClosable={false}
                keyboard={false}
                onCancel={() => {
                    this.onCancel()
                }}
                width={800}
                destroyOnClose={true}
                okText="确定"
                footer={
                    this.renderFooter()
                }
            >
                <Scrollbars autoHide autoHeight autoHeightMax={650} autoHeightMin={250}>
                    <Row>
                        {/*固定字段*/}
                        {this.renderFixedForm()}
                        {/*扩展字段*/}
                        {this.renderDynamicForm()}
                        {/*附加信息*/}
                        {this.renderAuditRemarksForm()}
                    </Row>
                </Scrollbars>
            </Modal>
        )
    };

    renderFixedForm = () => {
        if (!(fixedFieldConfig && fixedFieldConfig.length)) return null;
        return fixedFieldConfig.map(item => {
            return this.renderFixedField(item)
        })
    };

    renderDynamicForm = () => {
        let variableFieldsSetting = this.state.variableFieldsSetting;
        if (!(variableFieldsSetting && variableFieldsSetting.length)) return null
        return variableFieldsSetting.map(item => {
            return this.renderFixedField(item)
        })
    };

    renderAuditRemarksForm = () => {
        let {formData, loadAuditRemarks} = this.state;
        let noDisabled = this.sysConfigStatus.indexOf(this.state.formData.statusName) > -1;
        return (
            <AuditRemarks
                key={loadAuditRemarks}
                formData={formData}
                ref={ref => this.auditRemarks = ref}
                isAuditing={this.isAuditInProgress() || this.reloadLingQuActivity.indexOf(formData.statusName) > -1}
                noDisabled={noDisabled}
                isUpdateInfo={this.state.isUpdateInfo}
            />
        )
    };

    onInformationChange = ({code, val, setState = true,labelCode}) => {
        eval(`${code} = val`);
        // 方案一 eval(`obj.${key}=value`);
        // 方案二 new Function('obj','key','value',`obj.${key}=value`)(obj,key,value);
        // 备注：只有动态字段需要使用${}包裹
        if (setState) {
            this.setState({}, () => {
                eventProxy.trigger('fieldsChange',{that:this,labelCode})
            });
        }
    };

    renderFixedField = ({
                            componentType = "input",
                            multiple = false,
                            auth = '',
                            value = "",
                            labelCode = "",
                            labelName = "未知",
                            placeholder = "请输入",
                            required = false,
                            disabled = false,
                            size = "default",
                            id = `position_${labelCode}`,
                            col = 12,
                            fieldProps = {},
                            options = {}
                        }) => {

        let onFieldsChange = (val, se) => {
            this.onInformationChange({code: value, val, setState: se,labelCode})
        };

        let isShow = showOrHide(fieldProps.show || true, this.getValueByKey);
        if (fieldProps.show && !isShow) {
            delete this.state.formData.ext[labelCode];
            return null;
        }

        // 判断是否拥有权限-渲染内容为占位
        if (!!auth && !this.permissionCheck(auth)) return <Col span={0} key={id} className='fieldsCol'></Col>;
        // 根据labelCode判断col是否有左右内边距
        let NoPadding = ["dangerDisposeList"].indexOf(labelCode) > -1;
        return (
            <Col span={col} key={id} className={NoPadding ? "noPaddingFieldsCol" : "fieldsCol"}>
                <PositionTypeContext.Provider
                    value={{
                        // 阵地类型改变控制验证名称按钮是否禁用
                        positionTypeItem: {...this.state.formData}, ...this.state,
                        positionTypeOnChange: (positionTypeItem) => this.setState({
                            positionTypeItem,
                            formData: {...this.state.formData, logo: positionTypeItem?.logo}
                        })
                    }}>
                    <FormItem
                        formKey={labelCode}
                        itemType={componentType}
                        label={this.renderLabel({labelName, ...fieldProps})}
                        fieldProps={{
                            ...fieldProps,
                            col,
                            required,
                            labelName,
                            value: eval(value),
                            onChange: onFieldsChange,
                            getExtendsField: (id) => {   //专属阵地平台点击获取维护字段方法
                                this.getExtendsField(id)
                            },
                            getPositionTypeId: (id) => {   //专属阵地平台点击获取维护字段方法
                                this.getExtendsField(id)
                            },
                            positionTypeId: this.state.formData.positionTypeId, //阵地平台id
                            positionId: this.state.formData.id, //阵地id
                            divisionName: this.state.formData.divisionName, //线上线下阵地
                            formInfoData: this.state.formData, //表单信息
                            getPositionAccount: (obj) => {   //验证名称获取账号
                                this.state.formData["account"] = obj.account;
                                this.setState({})
                            },
                            belongDeptId: this.state.formData.belongDeptId, //通过所属部门id获取用户
                            isAuditing: this.isAuditInProgress(),
                            onlyEdit: this.state.onlyEdit,
                            updateMainDeptName: (mainDeptName) => {
                                this.setState({
                                    formData: {
                                        ...this.state.formData,
                                        mainDeptName: mainDeptName
                                    }
                                })
                            },
                            isUpdateInfo: this.state.isUpdateInfo,
                            platformDivide: this.platformDivide === "no",
                        }}
                        required={required}
                        hasFeedback={true}
                        setValidatedStatus={!!this.state.formData.id}
                        options={
                            {
                                ...options
                            }
                        }
                    />
                </PositionTypeContext.Provider>
                <style>{`.fieldsCol{padding: 0 10px;}
                .noPaddingFieldsCol{padding: 0;}
                `}</style>
            </Col>
        )
    };

    renderLabel = ({labelName, fieldTip}) => {
        return (labelName && <span>
            {labelName}<Tooltip placement="top" title={fieldTip}>
            <span style={{
                display: fieldTip ? "inline-block" : "none",
                marginLeft: 5,
                cursor: 'pointer'
            }}><Icon type="question-circle"/></span></Tooltip>
        </span>)
    }

    signOutName = "已注销";

    getFooterContent = () => {
        let isCurrentUser = this.state.formData.belongDeptId === window?.currentUser?.defaultInfo?.dept?.id;

        // 修改内容
        if (this.state.updateContentStatus) {
            return (
                <>
                    <Button style={{margin: "10px 0px 10px 10px"}} onClick={() => {
                        this.updateContent();
                    }}>取消修改</Button>
                    <Button style={{margin: "10px 0px 10px 10px"}} onClick={() => {
                        this.save(null, null);
                    }}>确认</Button>
                </>
            )
        }

        // 显示申请更新、注销、删除、年审按钮
        if (!this.getCommonCondition(this.state.formData) &&
            !this.state.openStatus &&  //未打开状态
            this.state.formData.statusName !== this.signOutName  // 不是已注销（注销审核通过后不再走流程）
        ) {
            let render = this.renderUpdateBtn();
            // 直接注销只显示申请注销
            if (this.state.formData.cancelRecord) {
                render = this.renderUpdateBtn([2]);
            }
            let condition1 = this.permissionCheck("pms:positionManage:updateContent");
            let processTypeArr = JSON.parse(this.sysConfigGetValueByKey("positionManage.update.content.processType", "[0, 1, 4]"));
            let condition2 = processTypeArr.includes(this.state.formData.processType);
            return (
                <div style={PositionAdd.footerStyle}>
                    {isCurrentUser ? render : null}
                    {/*修改内容*/}
                    {condition1 && condition2 ? this.renderUpdateContentBtn() : null}
                    {this.renderOtherBtn()}
                    <SyncModal ref={ref => this.syncModal = ref}/>
                </div>
            );
        }

        if (!this.state.showNewAdd) {
            return (
                <div style={PositionAdd.footerStyle}>
                    <Spin spinning={this.state.bottomBtnLoading}>
                        {this.renderActivityBtn()}
                    </Spin>
                    {this.renderOtherBtn()}
                    <SyncModal ref={ref => this.syncModal = ref}/>
                </div>
            );
        }

        if (this.state.onlyEdit) {
            return (
                <div>
                    <Button onClick={() => {
                        this.okHandle(() => {
                            try {
                                this.onOk(null, null);
                            } catch (error) {
                                console.error("Error occurred in onOk:", error);
                            }
                        });
                    }}>保存</Button>
                    <Button style={{marginLeft: "10px"}} onClick={() => {
                        this.onCancel();
                    }}>取消</Button>
                </div>
            );
        }

        return (
            <div>
                {this.renderOtherBtn()}
            </div>
        );
    };

    renderFooter = () => {
        return this.getFooterContent();
    };

    // 不走流程，仅仅查看编辑阵地
    onlyEditInfo = (id, onlyEdit, processType) => {
        if (id) {
            this.getPositionInfoById(id, (data) => {
                this.setState({
                    showNewAdd: true,
                    onlyEdit,
                    formData: data,
                    addVisible: true,
                    isUpdateInfo: true,
                    id: id,
                    title: "账号信息"
                }, () => {
                    this.batchLoadAuditRemarks(data);
                });
            });
            this.getActivityType().then((activityTypeData) => {
                this.setState({
                    activityTypeData
                })
            });
        } else {
            let data = {
                processType,
                ext: {}, //动态字段
                activityExt: {},  //审核备注数据
            }
            this.setState({
                showNewAdd: true,
                onlyEdit,
                formData: data,
                addVisible: true,
                isUpdateInfo: true,
                title: "新增账号"
            }, () => {
                this.batchLoadAuditRemarks(data);
            });
        }
    }

    batchLoadAuditRemarks = (data) => {
        this.getActivityType().then((activityTypeData) => {
            this.auditRemarks.setFormData(data.processType, data.activityExt, activityTypeData);
        });
    }

    auditingStatusName = this.sysConfigGetValueByKey("position.manage.auditing.statusName", "提交至审核人,提交至宣传部,退回修改").split(",");

    //流程是否处在审核中
    isAuditInProgress() {
        const {formData} = this.state;
        if (!this.auditingStatusName || !formData || !formData.statusName || this.auditingStatusName.length === 0) {
            return false;
        }
        return this.auditingStatusName.indexOf(formData.statusName) > -1;
    }

    renderActivityBtn = () => {
        const {formData, activityTypeData, openStatus, bottomBtnLoading} = this.state;
        const activityTypeName = (activityTypeData && activityTypeData.find(item => item.type === formData.processType)?.name) || '';
        return (
            <>
                <ActivitiModal key={this.state.activitiKey} {...this.state.activityOption} ref={ref => this.activitiModal = ref}/>
                {openStatus && !bottomBtnLoading && <Button
                    onClick={() => {
                        this.updateInfo();
                        this.setState({openStatus: false, showNewAdd: true, loadAuditRemarks: uuid()})
                    }}>{`取消${activityTypeName}`}</Button>}
            </>
        );
    }

    // 底部按钮需要显示的流程类型
    defaultOpenActivity = [1, 2, 3, 4];

    renderUpdateBtn = (NO_NEED_ACTIVITY_TYPES = this.defaultOpenActivity) => {   //需要显示的流程类型按钮
        let {activityTypeData} = this.state;
        return activityTypeData
            .filter(item => item.status && NO_NEED_ACTIVITY_TYPES.indexOf(item.type) > -1)
            .map((item, index) => {
                return <Button key={index} style={{display: item.status ? "inline-block" : "none"}}
                               onClick={() => {
                                   this.updateInfo();
                                   this.loadActivity(item);
                               }}>{"申请" + item.name}</Button>
            })
            .filter(Boolean);
    };

    loadActivity = (item) => {
        this.setState({
            openStatus: true,
            bottomBtnLoading: true,
            formData: {
                ...this.state.formData,
                processType: item?.type
            }
        }, () => {
            this.initActivityConfig(this.state.formData)
        })
    }

    renderOtherBtn = () => {
        const {formData, variableFieldsSetting} = this.state;
        const {activityTypeData} = this.state;
        let deleteAuth = this.permissionCheck("pms:positionManage:deleteButton");
        return (
            <>
                {
                    (() => {
                        if (this.activitiBtns && (this.activitiBtns.length > 0)) {
                            let configBtns = this.sysConfigGetValueByKey("positionManage.saveBtn.activiti.btn", "撤回").split(",");
                            let result = false;
                            this.activitiBtns && this.activitiBtns.map(item => {
                                if (configBtns.indexOf(item.name) > -1) {
                                    result = false;
                                }
                            });
                            // （新增流程 && （新增 || （草稿 && (所属人=当前用户 || 创建人=当前用户)））  ====>>>> 显示
                            if (formData.processType === 0 && (!formData.statusName || (formData.statusName === "草稿" && (formData.belongUserAccount === window.currentUser.id || formData.createById === window.currentUser.id)))) {
                                result = true;
                            }
                            return result;
                        }
                        return false;
                    })() ?
                        <>
                            <Button style={{margin: "10px 0px 10px 10px"}} onClick={() => {
                                this.okHandle(() => {
                                    this.onOk(null, null)
                                })
                            }} type="primary">暂存</Button>
                            {this.state.id ?
                                <Button onClick={() => {
                                    this.okHandle(() => {
                                        this.delete()
                                    })
                                }} type="primary">删除</Button> : null}
                        </>
                        : null
                }
                {
                    deleteAuth && this.state.formData.statusName === this.signOutName ?
                        <Button onClick={() => {
                            this.okHandle(() => {
                                this.delete()
                            })
                        }} type="primary">删除</Button> : null
                }
                <style>{`.ant-modal-footer button + button{margin-left: 10px !important;}`}</style>
                {/*审核记录*/}
                {this.state.id ?
                    <AuditRecord btnType={"default"} btnStyle={{marginLeft: 10}} id={this.state.id}
                                 activityTypeData={activityTypeData} {...this.state.formData}
                                 isAuditing={this.isAuditInProgress()}
                                 isUpdateInfo={this.state.isUpdateInfo}
                                 positionRecordOnlineOpen={this.state.positionRecordOnlineOpen}
                                 variableFieldsSetting={variableFieldsSetting}/> : null}
                {this.state.id && this.state.positionRecordOnlineOpen && <Button style={{margin: "10px 0px 10px 10px"}} onClick={() => {
                    this.downRecordForm()
                }}>下载备案表</Button>}
                {this.state.id && this.state.formData.statusName !== this.signOutName && this.permissionCheck("pms:positionManage:sendRemind") ?
                    <SendRemind btnStyle={{marginLeft: 10}} positionId={this.state.id}/> : null}
                <Button style={{margin: "10px 0px 10px 10px"}} onClick={() => {
                    this.onCancel()
                }}>关闭</Button>
            </>
        )
    };

    renderUpdateContentBtn = () => {
        return <Button style={{margin: "10px 0px 10px 10px"}} onClick={() => {
            this.updateContent();
        }}>修改内容</Button>
    };

    downRecordForm = () => {
        this.checkRecordForm(() => {
            let {id} = this.state;
            this.request({
                url: "/cm-sites-media-consumer/position/handler/outPutToPdf",
                body: {positionId: id},
                method: "downloadGet",
                callBack: (data) => {
                },
                errorCallBack: () => {
                },
                serverVerify: {
                    serverErrorCallBack: () => {
                    }
                }
            })
        })
    }

    updateContent = () => {
        this.updateInfo();
        this.setState({
            updateContentStatus: !this.state.updateContentStatus,
        })
    };

    checkRecordForm = (callback) => {
        let {id} = this.state;
        this.request({
            url: "/cm-sites-media-consumer/position/handler/checkRecordFormTemplate",
            body: {positionId: id},
            method: "get",
            callBack: (data, status) => {
                if (status === 200) {
                    callback()
                }
            },
            errorCallBack: () => {
            },
            serverVerify: {
                serverErrorCallBack: () => {
                },
                isShowErrorMsg: true
            }
        })
    }

    tempData = []

    updateInfo = () => {
        this.setState((prevState) => {
            if (prevState.isUpdateInfo) {  //取消修改
                return ({
                    isUpdateInfo: !prevState.isUpdateInfo,
                    formData: this.tempData
                })
            }
            this.tempData = JSON.parse(JSON.stringify(this.state.formData));  //深拷贝数据 供点击取消修改按钮恢复数据使用
            return ({
                isUpdateInfo: !prevState.isUpdateInfo
            })
        });
    }

    //点击确定按钮,防止重复提交
    okHandle(callBack) {
        const {isRepeatClick} = this.state;
        if (isRepeatClick) {   //如果为true 开始执行
            this.setState({isRepeatClick: false})   //将isRepeatClick变成false，将不会执行处理事件
            callBack();
            const that = this;   // 为定时器中的setState绑定this
            setTimeout(function () {       // 设置点击延迟事件，1秒后将执行
                that.setState({isRepeatClick: true})   // 将isRepeatClick设置为true
            }, 1000);
        }
    };

    // 关闭弹窗
    onCancel = () => {
        this.setState({addVisible: false});
        if (typeof this.props.onCancel === 'function') {
            this.props.onCancel()
        }
    };

    // 保存成功后的回调
    onOkCall = () => {
        this.setState({addVisible: false}, () => {
            window.loading.hide();
        });
        if (typeof this.props.onOkCall === 'function') {
            this.props.onOkCall()
        }
    };

    getRecordInfo = () => {
        this.request({
            url: "/cm-sites-media-consumer/system/getCustomInfo",
            callBack: (response)=>{
                if (response) {
                    this.setState({
                        positionRecordOnlineOpen: response.positionRecordOnlineOpen,
                    })
                }
            }
        })
    }

    record;

    signOutNotRecord = (item) => {
        let data = {
            processType: item.type,
            ext: {}, //动态字段
            activityExt: {},  //审核备注数据
        }
        this.setState({
            formData: data,
            addVisible: true,
            isUpdateInfo: true,
            bottomBtnLoading: true,
            title: item.name,
            cancelRecord: true,  //单独添加一个标识符，用来判断是否是直接注销
        }, () => {
            this.getRecordInfo();
            this.initData(data);   //这样做的目的是每次打开弹窗都能实时获取到最新的数据
        })
    }

    showAddModal = (item) => {
        let data = {
            processType: item.type,
            ext: {}, //动态字段
            activityExt: {},  //审核备注数据
        }
        this.setState({
            formData: data,
            addVisible: true,
            isUpdateInfo: true,
            bottomBtnLoading: true,
            title: "我要" + item.name,
        }, () => {
            this.initData(data);   //这样做的目的是每次打开弹窗都能实时获取到最新的数据
        })
    }

    showEditModal = (id) => {
        getActHistory({bizKey: id}, (history) => {
            this.getPositionInfoById(id, (data) => {
                let isCurrentUser=false
                const candidateInfo = history[0]?.candidateInfo && Array.isArray(history[0].candidateInfo)? history[0].candidateInfo: [];
                isCurrentUser = candidateInfo.some(item => item.userId === window?.currentUser?.id)
                // let noCurrentUser = window?.currentUser?.defaultInfo?.dept?.id !== data.belongDeptId;
                // 需要开启编辑模式
                 let isUpdateInfo = !(data.id && (!(this.sysConfigStatus.indexOf(data.statusName) > -1)))||isCurrentUser
                // -------特殊逻辑--------
                // 具有分派权限的人选了所属部门用户直接暂存草稿到选的这个人，与上面的逻辑互斥
                if (data.statusName === "草稿" && this.permissionCheck("pms:positionManage:assignPosition")) {
                    isUpdateInfo = true;
                }
                // 新增审核不通过可编辑
                // 不配在配置项的原因是：新增审核不通过直接显示提交按钮，而更新注销审核不通过等显示的是申请更新...等按钮，这时候是不可编辑模式
                if((data.processType === 0 && data.statusName && data.statusName.indexOf("审核不通过") > -1)||isCurrentUser ) {
                    isUpdateInfo = true;
                }
                this.setState({
                    formData: data,
                    addVisible: true,
                    isUpdateInfo,
                    bottomBtnLoading: true,
                    id: id,
                    title: "账号信息"
                }, () => {
                    this.getRecordInfo();
                    this.initData(data); //这样做的目的是每次打开弹窗都能实时获取到最新的数据
                });
            });
        })

    };

    // 快速入口
    entryOpenModal = (id, activityTypeItem) => {
        this.getPositionInfoById(id, (data) => {
            this.setState({
                formData: data,
                addVisible: true,
                isUpdateInfo: true,
                bottomBtnLoading: true,
                id: id,
                title: "账号信息"
            }, () => {
                this.getRecordInfo();
                this.tempData = JSON.parse(JSON.stringify(this.state.formData));
                this.entryInitData(activityTypeItem); //这样做的目的是每次打开弹窗都能实时获取到最新的数据
            });
        });
    };

    entryInitData(data) {
        this.getActivityType().then((activityTypeData) => {
            this.setState({activityTypeData});
            return this.loadActivity(data); // 加载流程配置
        }); //流程类型数据
    }

    getPositionInfoById(id, callBack) {
        this.request({
            url: "/cm-sites-media-consumer/position/management/findPositionById",
            body: {
                id
            },
            callBack: (data) => {
                if (!data) {
                    message.info("账号异常");
                    return;
                }
                if (data) {
                    callBack(data);
                }
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    // 中断错误方法
    errFun = (msg, call) => {
        window.loading.hide();
        if (msg) {
            message.warning(msg, 1);
        }
        call && call(false);
    };

    // 表单校验
    checkForm = (activiti, call) => {
        let {variableFieldsSetting} = this.state;
        // 隐藏的字段不校验
        let newVariableFieldsSetting = variableFieldsSetting.filter(item => {
            return !item.fieldProps.show || showOrHide(item.fieldProps.show, this.getValueByKey)
        })
        // 1、校验固定字段
        for (var i = 0; i < fixedFieldConfig.length; i++) {
            let item = fixedFieldConfig[i];
            // 针对权限判断
            if (item.auth && !this.permissionCheck(item.auth)) {
                continue;
            }
            let val = Function(`return ${item.value}`).call(this);   //这个得注意，eval会导致this指向发生变化
            let message = item.fieldProps?.message;
            // 校验必填
            if (item.required) {
                if (!((typeof val === "number" && val) || (val?.trim()?.length))) {
                    this.errFun(message);
                    return false;
                }
            }
            // 校验正则
            if (item.options?.rules?.length) {
                let regularRules = item.options.rules;
                for (let k = 0; k < regularRules.length; k++) {
                    let ruleItem = regularRules[k];
                    if (val && val.trim() && ruleItem.pattern && !new RegExp(ruleItem.pattern).test(val)) {
                        this.errFun(ruleItem.message);
                        return false;
                    }
                    if (val && val.trim() && val.trim().length > ruleItem.max && ruleItem.max !== 0) {
                        let regMessage = `${item.labelName}内容不能超过${ruleItem.max}个字`;
                        this.errFun(regMessage);
                        return false;
                    }
                }
            }
        }

        // 2、校验动态字段
        for (let j = 0; j < newVariableFieldsSetting.length; j++) {
            let dynamicItem = newVariableFieldsSetting[j];
            let dynamicItemVal = Function(`return ${dynamicItem.value}`).call(this);
            // 校验必填
            if (dynamicItem.required) {
                if (!((typeof dynamicItemVal === "number" && dynamicItemVal) ||
                    (dynamicItemVal && typeof dynamicItemVal === "string" && dynamicItemVal?.trim()?.length) ||
                    (dynamicItemVal && Array.isArray(dynamicItemVal) && dynamicItemVal?.length) ||
                    (dynamicItemVal && typeof dynamicItemVal === 'object' && !Array.isArray(dynamicItemVal) && Object.keys(dynamicItemVal).length) ||
                    (dynamicItemVal && typeof dynamicItemVal === "boolean")
                )) {
                    this.errFun(dynamicItem.fieldProps.message);
                    return false;
                }
                if(dynamicItemVal && Array.isArray(dynamicItemVal) && dynamicItemVal.some(item => item.status === "uploading")) {
                    this.errFun(dynamicItem.fieldProps.message);
                    return false;
                }
            }
            // 校验正则
            if (dynamicItem?.options?.rules?.length) {
                let dynamicRegularRules = dynamicItem.options.rules;
                for (let n = 0; n < dynamicRegularRules.length; n++) {
                    let ruleItem = dynamicRegularRules[n];
                    if (ruleItem.ruleType === 1 && dynamicItemVal && dynamicItemVal?.trim() && ruleItem.pattern && !(new RegExp(ruleItem.pattern).test(dynamicItemVal))) {
                        this.errFun(ruleItem.message);
                        return false;
                    }
                    if (ruleItem.ruleType === 0 && dynamicItemVal?.trim()?.length > ruleItem.max && ruleItem.max !== 0) {
                        let regMessage = `${dynamicItem.labelName}内容不能超过${ruleItem.max}个字`;
                        this.errFun(regMessage);
                        return false;
                    }
                }
            }
        }
        // 审核备注校验
        if (!(this.auditRemarks && this.auditRemarks.checkForm())) {
            return false;
        }
        call && call();
        return true;
    };

    delete() {
        Modal.confirm({
            title: "确认删除吗？",
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                let id = this.state.id;
                this.request({
                    url: "/cm-sites-media-consumer/position/management/deletePositionById",
                    body: {id},
                    callBack: (data, status) => {
                        if (data && status === 200) {
                            message.success("删除成功");
                            this.onOkCall();
                        } else {
                            message.info("删除失败");
                        }
                    },
                    errorCallBack: () => {

                    },
                    serverVerify: {
                        serverErrorCallBack: () => {

                        }
                    }
                });
            },
            onCancel() {
            },
        })
    }

    // 保存
    onOk = (activiti, call) => {
        window.loading.show()
        let body = this.checkForm();
        if (!body) {
            window.loading.hide()
            call && call(false);
            return false
        }
        this.save(activiti, call);
    };

    // 暂存
    save = (activiti, call) => {
        let that = this;
        let url = '/cm-sites-media-consumer/position/management/addPosition';
        if (that.state.id) {
            url = "/cm-sites-media-consumer/position/management/updatePosition";
        }
        this.state.formData.activityExt = (this.auditRemarks && this.auditRemarks.getFormData()) || {};
        if (this.state.cancelRecord) this.state.formData.cancelRecord = this.state.cancelRecord; //添加一个新字段，用于判断是否直接注销备案
        this.request({
            url,
            method: 'POST',
            body: this.state.formData,
            contentType: 'json',
            loading: false,
            callBack: function (res, status, allData) {
                if (res) {
                    call && call(res);
                    that.state.id = res.id;
                    if (!activiti) { //点击了暂存按钮
                        message.success('保存成功！');
                        that.onOkCall()
                    }
                    that.updateProcessAndData(res)
                } else {
                    message.info('保存失败！');
                    call && call(false);
                }
            },
            errorCallBack: function (e) {
                call && call(false);
                window.loading.hide();
                message.info('保存失败！');
            },
            serverVerify: {
                serverErrorCallBack: () => {
                    call && call(false);
                    window.loading.hide();
                },
                isShowErrorMsg: true
            }
        });
    };

    // 更新流程稿件
    updateProcessAndData = (body) => {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            body,
            loading: false,
            callBack: (res) => {

            }
        })
    };

    // 状态映射
    statusReflection = (statusName) => {
        const processType = this.state.formData.processType;
        switch (statusName) {
            case "审核通过":
                return processType === 2 ? this.signOutName : statusName;
            default:
                return statusName;
        }
    };

    /**
     * 阵地修改状态
     */
    updateStatusName = (statusName, activiti, call) => {
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';
        let newStatusName = this.statusReflection(statusName);
        let params = {
            "statusName": newStatusName,
            "id": id,
        };
        this.request({
            url: '/cm-sites-media-consumer/position/management/updatePositionStatusName',
            method: 'POST',
            body: params,
            loading: false,
            callBack: (res) => {
                if (res) {
                    call && call({status: true, msg: "流程推进后状态修改成功。"});
                } else {
                    call && call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (res) {
                window.loading.hide();
                call && call({status: false, msg: "流程推进后状态修改失败。"});
            },
            serverVerify: {
                serverErrorCallBack: () => {
                    call && call({status: false, msg: "流程推进后状态修改失败。"});
                    window.loading.hide();
                },
                isShowErrorMsg: true
            }
        });
    };

}
